export default "__VITE_ASSET__1a3f4028__"